module.exports = __webpack_public_path__ + "img/1970East-044_WEB-min.d8cc56bf.jpg";